import { css } from '@/styled-system/css';

/** IconButton's own 16px Icon wrapper merges onto our Gleam.Root; size it to the icon so the button centres on the icon. */
export const topBarIconButtonStyles = css.raw({
  '& > [data-c11n-component="Icon"]': {
    boxSize: 'icon.md',
  },
});
